import Image from 'next/image';
import { useRouter } from 'next/router';
import type { RefObject } from 'react';

import closeIcon from '@/assets/images/icons/close-icon.svg';

type SellKycProps = {
  closeKycRef: RefObject<HTMLButtonElement>;
  openKycRef: RefObject<HTMLButtonElement>;
  text?: string;
  heading?: string;
  showCancel?: boolean;
};

export const SellKycModal = (props: SellKycProps) => {
  const {
    closeKycRef,
    text = 'You need to complete your KYC for selling gold',
    heading = 'PAN & Aadhar Verification Needed',
    showCancel = true,
  } = props;
  const router = useRouter();

  return (
    <div
      className={`modal loanDetails__modal repayModal visitSchedule pledge firstModal otpModal kycConfirmModal sellConfirm static `}
      id="kycModal"
      role="dialog"
      tabIndex={-1}
      aria-labelledby="kycModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <form autoComplete="off">
            <div className="header border-0 p-0">
              <div className="modal__title align-items-center">
                <div className="left">
                  <p className="text--bold text--black label sell_p mb-0">
                    {heading}
                  </p>
                </div>
                <button
                  type="button"
                  ref={closeKycRef}
                  data-dismiss="modal"
                  onClick={() => closeKycRef.current?.click()}
                >
                  <Image
                    style={{ color: undefined }}
                    className="img-fluid"
                    src={closeIcon}
                    alt="close icon"
                  />
                </button>
              </div>
              <p className="text--regular text--gray desc">{text}</p>
            </div>
            <div className="action-container mt-0">
              {showCancel && (
                <button
                  className="custom__button custom__button--dark border-btn backBtn text--bold w-100"
                  data-dismiss="modal"
                  type="button"
                  onClick={() => closeKycRef.current?.click()}
                  id="DG_kyc-cancel"
                >
                  Cancel
                </button>
              )}
              <button
                className="custom__button custom__button--dark text--semi w-100"
                type="button"
                onClick={() => {
                  closeKycRef.current?.click();
                  router.push('/account-and-settings');
                }}
                id="DG_kyc-complete"
              >
                Complete KYC
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
